const Bovemij = window.Bovemij || {};

Bovemij.Events = Bovemij.Events || {};
Bovemij.Events.OPEN_ROOT_MODAL = "open-root-modal";
Bovemij.Events.OPEN_MODAL = "open-modal";
Bovemij.Events.OPEN_SIDEBAR_MODAL = "open-sidebar-modal";
Bovemij.Modal = Bovemij.Modal || {};

Bovemij.Modal.Action = {
  DISMISS: "dismiss",
  CONFIRM: "confirm",
  NOTHING: "nothing"
};

export { Bovemij };
